import { SubmitDataType } from "@data-types/sow/PlayerSowTypes";
import { httpClient } from "@utils";

import {
	SowQuestionResponse,
	SowSubmissionResponse,
} from "@api-types/sow/PlayerSowApiTypes";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
class PlayerSowApiService {
	static baseUrl(context: ApiRequestContextData | null) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/sow`;
	}

	static questionsUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/sow-questions?embed=SOWQuestionOptions&translate=true`;
	}

	static getRequestHeadersPost(context: ApiRequestContextData | null) {
		const appHeaders = getApplicationRequestHeaders(context);
		return appHeaders;
	}

	static getRequestHeadersGet = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getSowQuestions(): Promise<SowQuestionResponse> {
		const context = getApiRequestContext();

		const response = await httpClient.get(
			this.questionsUrl(),
			this.getRequestHeadersGet(context)
		);
		return response;
	}

	static async getSowSubmissionStatus(
		requestId: string,
		userId: string,
		options: ContextOptions
	): Promise<SowSubmissionResponse> {
		const context = getApiRequestContext(options);

		const response = await httpClient.get(
			`${this.baseUrl(context)}/submission-status/${requestId}/${userId}`,
			this.getRequestHeadersGet(context),
			{},
			"home"
		);

		return response;
	}

	static async submitSow(
		data: SubmitDataType,
		options: ContextOptions
	): Promise<any> {
		const context = getApiRequestContext(options);
		const formData = new FormData();

		data.files.forEach((file) => {
			formData.append("file", file);
		});

		formData.append("fileData", JSON.stringify(data.fileData));
		formData.append("message", data.message);
		formData.append("requestId", data.requestId);
		formData.append("userId", data.userId);
		formData.append("answers", JSON.stringify(data.answers));
		formData.append("isAccepted", JSON.stringify(data.isAccepted));

		return await httpClient.post(
			`${this.baseUrl(context)}/submit`,
			formData,
			this.getRequestHeadersPost(context)
		);
	}
}

export default PlayerSowApiService;
